import Icon from '@mui/icons-material/Warning';
import { SvgIconPropsOverrides } from '../../../model/icon';

export default function WarningIcon({ className = '', ...props }: SvgIconPropsOverrides) {
	return <Icon className={`${className}`} {...props} />;
}
